// samvad-platform/admin-frontend/src/pages/AuthCallback.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function AuthCallback() {
  const { refresh, user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Re-fetch the user data now that the cookie is set
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!loading && user) {
      navigate("/", { replace: true });
    } else if (!loading && !user) {
      navigate("/login", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        className="devanagari-watermark"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: 320,
          background:
            "linear-gradient(135deg, rgba(194,108,27,0.08) 0%, rgba(194,108,27,0.01) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          pointerEvents: "none",
          userSelect: "none",
          fontWeight: 800,
        }}
      >
        प्रवेश
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
          zIndex: 1,
          padding: "48px 64px",
          background: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: 24,
          border: "1px solid rgba(194, 108, 27, 0.15)",
          boxShadow: "0 12px 48px -12px rgba(0, 0, 0, 0.08)",
        }}
      >
        <div
          className="loader"
          style={{ width: 36, height: 36, borderWidth: 3 }}
        />
        <p
          style={{
            margin: 0,
            fontFamily: "var(--serif)",
            fontSize: 18,
            fontStyle: "italic",
            color: "var(--ink-800)",
            letterSpacing: "0.02em",
          }}
        >
          Finalising your secure session...
        </p>
      </div>
    </div>
  );
}
